export const REDUCED_JOURNEY_SUBJECTS = ['landlord', 'employer']

export const TENANT_SUBJECTS = ['tenant', 'applicant']
